import { getYearImpots } from '../services/utils'

export const BASE_URL: string | undefined = process.env.REACT_APP_API_HOST
export const AUTH_TOKEN: string | undefined = process.env.REACT_APP_AUTH_TOKEN
export const EXTENDED_AUTH_TOKEN: string | undefined =
  process.env.REACT_APP_EXTENDED_AUTH_TOKEN
export const STATUS = {
  idle: 'idle',
  pending: 'pending',
  loaded: 'loaded',
  failed: 'failed',
  validated: 'validated',
}
export const LOCALSTORAGE_ITEM: string =
  process.env.REACT_APP_LOCALSTORAGE_ITEM || ''
export const BAD_REQUEST = 400
export const UNAUTHORIZED = 401
export const INTERNAL_SERVER_ERROR = 500
export const FORBIDDEN_ERROR = 403

export const PERSONNE_TYPE_ID_1 = 1
export const PERSONNE_TYPE_ID_2 = 2

export const DOCUMENT_TYPE_ID_1 = 1
export const DOCUMENT_TYPE_ID_3 = 3
export const DOCUMENT_TYPE_ID_4 = 4
export const DOCUMENT_TYPE_ID_28 = 28
export const DOCUMENT_TYPE_ID_50 = 50
export const DOCUMENT_TYPE_ID_93 = 93
export const DOCUMENT_TYPE_ID_102 = 102
export const DOCUMENT_TYPE_ID_103 = 103
export const DOCUMENT_TYPE_ID_104 = 104
export const DOCUMENT_TYPE_ID_105 = 105
export const DOCUMENT_TYPE_ID_131 = 131

export const ALERT_MESSAGES: { [propName: string]: any } = {
  empty: {},
  mandatory: { type: 'error', message: 'Ce champ est obligatoire.' },
  fileUpload: {
    type: 'error',
    message:
      'Le format du fichier n’est pas accepté. Veuillez charger un document aux formats indiqués.',
  },
  pending: {
    type: 'warning',
    message:
      'Votre justificatif est en cours de vérification par nos équipes. Vous pouvez passer à l’étape suivante',
  },
  pendingNotValid: {
    type: 'warningOCR',
    message: "La pièce n'a pas pu être validée automatiquement",
    messageLine2: 'Merci de vérifier votre document et de le charger à nouveau',
  },
  pendingIncomplete: {
    type: 'warningOCR',
    message: 'La pièce semble incomplète (recto ou verso manquant)',
    messageLine2: 'Merci de vérifier votre document et de le charger à nouveau',
  },
  pendingExpired: {
    type: 'expired',
    message: 'La pièce semble expirée',
    messageLine2: 'Merci de vérifier votre document et de le charger à nouveau',
  },
  validated: { type: 'success', message: "Pièce d'identité validé(e)" },
  fileType: {
    type: 'error',
    message: 'Seuls les documents au format JPG, PNG et PDF sont autorisés.',
  },
  fileSize: {
    type: 'error',
    message: 'La taille du fichier dépasse la limite autorisée de 20Mo.',
  },
  fileSizeHalf: {
    type: 'error',
    message: 'La taille du fichier dépasse la limite autorisée de 10Mo.',
  },
  valid: {
    [DOCUMENT_TYPE_ID_1]: {
      type: 'success',
      message: "Pièce d'identité validé(e)",
    },
    [DOCUMENT_TYPE_ID_3]: {
      type: 'success',
      message: "Avis d'imposition [A-1] sur le revenu [A-2] validé(e)",
    },
    [DOCUMENT_TYPE_ID_4]: {
      type: 'success',
      message: 'Bulletin de salaire [m-1] validé(e)',
    },
    [DOCUMENT_TYPE_ID_28]: {
      type: 'success',
      message: "Attestation d'hébergement validé(e)",
    },
    [DOCUMENT_TYPE_ID_50]: {
      type: 'success',
      message: 'Justificatif de domicile validé(e)',
    },
    [DOCUMENT_TYPE_ID_93]: {
      type: 'success',
      message: 'Certificat de perte de nationalité validé(e)',
    },
    [DOCUMENT_TYPE_ID_102]: {
      type: 'success',
      message: 'Justificatif (allocations familiales, RSA,…) validé(e)',
    },
    [DOCUMENT_TYPE_ID_103]: {
      type: 'success',
      message: 'Attestation (jugement de divorce) validé(e)',
    },
    [DOCUMENT_TYPE_ID_104]: {
      type: 'success',
      message: 'Justificatif à votre convenence validé(e)',
    },
    [DOCUMENT_TYPE_ID_105]: {
      type: 'success',
      message:
        'Justificatif pays résidence différent pays résidence fiscale validé(e)',
    },
    [DOCUMENT_TYPE_ID_131]: {
      type: 'success',
      message: 'Attestation sur l’honneur validé(e)',
    },
  },
  invalid: {
    type: 'error',
    message: 'Merci de joindre un nouveau document.',
  },
  validationButton: {
    type: 'error',
    message: 'Merci de valider les documents avant de poursuivre.',
  },
  minLengthPhone: {
    type: 'error',
    message: 'Votre numéro de téléphone doit être composé de 10 à 15 chiffres.',
  },
  patternNumberPlusMinus: {
    type: 'error',
    message: 'Caractères autorisés : chiffres, espace, +, -.',
  },
  patternZeroOnly: {
    type: 'error',
    message: 'Votre numéro de téléphone ne doit pas contenir que des 0.',
  },
  blackListDomain: {
    type: 'error',
    message:
      "Merci d'utiliser une adresse e-mail valide, non jetable et/ou non temporaire.",
  },
  validEmail: {
    type: 'error',
    message: 'Merci de saisir une adresse e-mail valide.',
  },
  emailConfirmation: {
    type: 'error',
    message: 'Les e-mails saisis ne sont pas identiques.',
  },
  tinMinLength: {
    type: 'error',
    message: 'Veuillez renseigner 9 caractères numériques.',
  },
  tinMaxLength: {
    type: 'error',
    message: 'Veuillez renseigner 9 caractères numériques.',
  },
  tinInputPattern: {
    type: 'error',
    message: 'Veuillez renseigner 9 caractères numériques.',
  },
}

export const ALLOW_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf']
export const ALLOW_SIZE = 5000000 * 4 // 20MB

export const STEP1_IDENTITY_UPLOAD_FILES: { [propName: string]: string[] } = {
  '1': [
    'Carte Nationale d’Identité (recto)',
    'Carte Nationale d’Identité (verso)',
  ],
  '2': ['Passeport'],
  '3': ['Titre de Séjour (recto)', 'Titre de Séjour (verso)'],
}

export const STEP1_OTHER_UPLOAD_FILES: { [propName: string]: string[] } = {
  '1': ['Carte de résident'],
  '2': ['Récépissé de demande de carte de séjour'],
  '3': ['Carte de séjour'],
}

export const STEP2_DOCUMENT_TYPE_FILES: { [propName: string]: string[] } = {
  '1': [
    `Veuillez fournir votre avis d’impôt établi en ${new Date().getFullYear()} sur vos revenus ${getYearImpots()} (retrouvez ces informations en haut de la première page de votre avis d’impôt)`,
  ],
  '2': [
    'Veuillez fournir un bulletin de salaire/retraite valide de moins de deux mois',
  ],
  '3': ['Dernier justificatif (allocations familiales, RSA,…)'],
  '4': ['Attestation (jugement de divorce,…)'],
  '5': ['Justificatif à votre convenance'],
}

export const DOCUMENT_INVALID_STATUS: { [propName: string]: string } = {
  '0': 'Document invalide',
  '1': 'Ce document ne fait pas partie des documents acceptés',
  '2': 'Document non conforme',
  '3': 'Document illisible ou tronqué',
  '4': 'Ce document ne comporte pas toutes les informations nécessaires',
  '5': 'Ce document ne correspond pas à la personne concernée',
  '6': 'Document incohérent',
  '7': 'Document expiré',
}

export const FILE_STATUS = {
  pending: 'pending',
  loaded: 'loaded',
}

export const NEXT = 'next'
export const MAX_CARDS = 10

export const DOCUMENT_TYPE_UPLOAD_FILES_FOR_STEPS: {
  [propName: string]: any
} = {
  '0': {
    '1': [
      { typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 },
      { typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 },
    ],
    '2': [{ typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 }],
    '3': [
      { typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 },
      { typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 },
    ],
    '4': [{ typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 }],
  },
  '0-2': {
    '1': [{ typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 }],
    '2': [{ typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 }],
    '3': [{ typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 }],
    '4': [{ typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_1 }],
  },
  '1': {
    on: [{ typeId: DOCUMENT_TYPE_ID_3, personTypeId: PERSONNE_TYPE_ID_1 }],
    '1': [{ typeId: DOCUMENT_TYPE_ID_3, personTypeId: PERSONNE_TYPE_ID_1 }],
    '2': [{ typeId: DOCUMENT_TYPE_ID_4, personTypeId: PERSONNE_TYPE_ID_1 }],
    '3': [{ typeId: DOCUMENT_TYPE_ID_102, personTypeId: PERSONNE_TYPE_ID_1 }],
    '4': [{ typeId: DOCUMENT_TYPE_ID_103, personTypeId: PERSONNE_TYPE_ID_1 }],
    '5': [{ typeId: DOCUMENT_TYPE_ID_104, personTypeId: PERSONNE_TYPE_ID_1 }],
    '6': [{ typeId: DOCUMENT_TYPE_ID_131, personTypeId: PERSONNE_TYPE_ID_1 }],
  },
  '3': {
    periodic_remediation: {
      '1': [{ typeId: DOCUMENT_TYPE_ID_50, personTypeId: PERSONNE_TYPE_ID_1 }],
      '2': [
        { typeId: DOCUMENT_TYPE_ID_28, personTypeId: PERSONNE_TYPE_ID_1 },
        { typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_2 },
        { typeId: DOCUMENT_TYPE_ID_50, personTypeId: PERSONNE_TYPE_ID_2 },
      ],
      '3': [
        { typeId: DOCUMENT_TYPE_ID_28, personTypeId: PERSONNE_TYPE_ID_1 },
        { typeId: DOCUMENT_TYPE_ID_50, personTypeId: PERSONNE_TYPE_ID_1 },
      ],
      '4': [{ typeId: DOCUMENT_TYPE_ID_1, personTypeId: PERSONNE_TYPE_ID_2 }],
    },
    '1': [{ typeId: DOCUMENT_TYPE_ID_50, personTypeId: PERSONNE_TYPE_ID_1 }],
    '2': [
      { typeId: DOCUMENT_TYPE_ID_28, personTypeId: PERSONNE_TYPE_ID_1 },
      { typeId: DOCUMENT_TYPE_ID_50, personTypeId: PERSONNE_TYPE_ID_2 },
    ],
    '3': [
      { typeId: DOCUMENT_TYPE_ID_28, personTypeId: PERSONNE_TYPE_ID_1 },
      { typeId: DOCUMENT_TYPE_ID_50, personTypeId: PERSONNE_TYPE_ID_1 },
    ],
  },
  '4': {
    '0': [{ typeId: DOCUMENT_TYPE_ID_93, personTypeId: PERSONNE_TYPE_ID_1 }],
    '1': [{ typeId: DOCUMENT_TYPE_ID_105, personTypeId: PERSONNE_TYPE_ID_1 }],
    '2': [{ typeId: DOCUMENT_TYPE_ID_105, personTypeId: PERSONNE_TYPE_ID_1 }],
    '3': [{ typeId: DOCUMENT_TYPE_ID_105, personTypeId: PERSONNE_TYPE_ID_1 }],
    '4': [{ typeId: DOCUMENT_TYPE_ID_105, personTypeId: PERSONNE_TYPE_ID_1 }],
    '5': [{ typeId: DOCUMENT_TYPE_ID_105, personTypeId: PERSONNE_TYPE_ID_1 }],
    '6': [{ typeId: DOCUMENT_TYPE_ID_105, personTypeId: PERSONNE_TYPE_ID_1 }],
  },
}

export const STEP4_MAIN_PERSON_OPTIONS = ['1', '3']

export const AUTRE = 'Autre'
export const NEE_USA_FILE_INDEX = 0
export const SECOND_NEE_USA_FILE_INDEX = 1
export const FRENCH_COLONIES_FILE_INDEX = 1

export const JOURNEY_COMPLETE_STATUSES = ['3', '4']
export const JOURNEY_REACCESS_STATUS = '5'

export const INVALID = 'invalid'
export const MEDIUM_RISK = 'MR'
export const LOW_RISK = 'LR'
export const HIGH_RISK = 'HR'

export const ASYNC_SELECT_MAX_OPTIONS = 100

export const DONT_CHANGE_DOMICILE_FISCALE = ''
export const DOMICILE_FISCALE_DIFFERENT = '1'
export const IS_YOUR_DOMICILE_FISCALE_DIFFERENT = '2'

export const DEFAULT_ERROR_MESSAGE = [
  'The response is not a JSON',
  'The response is not empty',
  'The request responded with status:',
]

export const LOCAL_STORAGE_ITEM_CITIES = 'cities_list'
export const LOCAL_STORAGE_ITEM_CITIES_TTL = 24 * 60 * 60 * 1000 // 24 hours

export const DOCUMENT_VERIFICATION_STATUS = {
  NOT_VERIFIED: 0,
  OUT_OF_BOUNDS: 1,
  FRAUD: 2,
  UNREADABLE: 3,
  MISSING_VERSO: 4,
  NOT_CONSISTENT_NAME: 5,
  NOT_CONSISTENT_OTHER: 6,
  EXPIRED: 7,
  VERIFIED_NOT_ELIGIBLE: 8,
  VERIFIED_ELIGIBLE: 9,
}

export const DOCUMENT_UPLOAD_RETRY_LIMIT = 2

export const STATUS_VERIFICATION_ALLOW_UPLOAD_RETRY = [
  DOCUMENT_VERIFICATION_STATUS.NOT_VERIFIED,
  DOCUMENT_VERIFICATION_STATUS.OUT_OF_BOUNDS,
  DOCUMENT_VERIFICATION_STATUS.UNREADABLE,
  DOCUMENT_VERIFICATION_STATUS.MISSING_VERSO,
  DOCUMENT_VERIFICATION_STATUS.EXPIRED,
]

export const DOCUMENT_STATUS_FOR_MODAL_TO_OPEN = [0, 1, 3, 5, 7]

export const DOCUMENT_STATUS_FOR_MODAL_TO_OPEN_MESSAGES: {
  [propName: number]: string
} = {
  0: "La pièce n'a pas pu être reconnue automatiquement.",
  1: "La pièce n'a pas pu être reconnue automatiquement.",
  3: "La pièce n'a pas pu être reconnue automatiquement.",
  5: 'La pièce chargée ne semble pas appartenir au titulaire attendu :',
  7: 'La pièce chargée semble expirée.',
}

export const DOCUMENT = {
  FRONT: '0',
  BACK: '1',
}

export const DOCUMENT_STATUS_VERIFIED_NOT_ELIGIBLE = 8

export const OTHER_SELECT_INDEX = '4'
export const AUTOMATICALLY_VALIDATED_WORKFLOW_STATUS = 10500

export const PERIODIC_REMEDIATION_PARAMETER = 'remediation_periodique'
export const POSTBLOCAGE_REMEDIATION_PARAMETER = 'remediation_postblocage'

export const YES_VALUE = '1'
export const NO_VALUE = '0'
